export default "__VITE_ASSET__BadxKmmu__"